import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { ADMIN_PHONG_HOP_PREFIX_URL } from './constants/config.admin-phong-hop'

const ListPageAdminPhongHop = lazy(
  () => import('./pages/ListPage.AdminPhongHop')
)

const AdminPhongHopRouters: AppRouterItem[] = [
  {
    path: `${ADMIN_PHONG_HOP_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAdminPhongHop />
      </LoadingLazyComponents>
    ),
  },
]

export default AdminPhongHopRouters
